import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: [
        ['rock', 0.7],
        ['shadow', 0.3],
      ],
      d: 'M0.5,-4.5h0.5v0.5h-0.5zM-2,-4h2v0.5h-2zM0.5,-4h4v0.5h-4zM-3.5,-3.5h0.5v0.5h-0.5zM-2.5,-3.5h2.5v0.5h-2.5zM0.5,-3.5h5v0.5h-5zM-4.5,-3h1.5v0.5h-1.5zM-2.5,-3h8v0.5h-8zM6,-3h0.5v0.5h-0.5zM-5,-2.5h10.5v0.5h-10.5zM6,-2.5h1.5v0.5h-1.5zM-6,-2h0.5v0.5h-0.5zM-5,-2h13.5v0.5h-13.5zM-7,-1.5h1.5v0.5h-1.5zM-5,-1.5h14v0.5h-14zM-7.5,-1h7v0.5h-7zM2,-1h7v0.5h-7zM-8,-0.5h6.5v0.5h-6.5zM3,-0.5h6v0.5h-6zM-9,0h6.5v0.5h-6.5zM4,0h5v0.5h-5zM-9,0.5h6v0.5h-6zM4.5,0.5h4.5v0.5h-4.5zM-9,1h5.5v0.5h-5.5zM5.5,1h3.5v0.5h-3.5zM-9,1.5h4.5v1h-4.5zM6,1.5h3v1h-3zM-9,2.5h4v0.5h-4zM6.5,2.5h2.5v0.5h-2.5zM-9,3h3.5v0.5h-3.5zM6.5,3h2v0.5h-2zM-9,3.5h3v1h-3z',
    },
    {
      paint: [
        ['rock', 0.73],
        ['sail', 0.27],
      ],
      d: 'M-2,-6h4v0.5h-4zM-3.5,-5.5h7.5v0.5h-7.5zM-5,-5h5v0.5h-5zM0.5,-5h4.5v0.5h-4.5zM-6,-4.5h4v0.5h-4zM4,-4.5h1.5v0.5h-1.5zM-6.5,-4h3v0.5h-3zM6,-4h0.5v0.5h-0.5zM-7.5,-3.5h3v0.5h-3zM6.5,-3.5h0.5v0.5h-0.5zM-8,-3h2.5v0.5h-2.5zM-9,-2.5h3v0.5h-3zM-9.5,-2h2.5v0.5h-2.5zM-10,-1.5h2.5v0.5h-2.5zM-10,-1h2v0.5h-2zM-9,-0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'rock',
      d: 'M0,-5h0.5v0.5h-0.5zM-2,-4.5h2.5v0.5h-2.5zM1,-4.5h3v0.5h-3zM5.5,-4.5h0.5v0.5h-0.5zM-3.5,-4h1.5v0.5h-1.5zM0,-4h0.5v1h-0.5zM4.5,-4h1.5v0.5h-1.5zM-4.5,-3.5h1v0.5h-1zM-3,-3.5h0.5v1h-0.5zM5.5,-3.5h1v0.5h-1zM-5.5,-3h1v0.5h-1zM5.5,-3h0.5v1h-0.5zM6.5,-3h1.5v0.5h-1.5zM-6,-2.5h1v0.5h-1zM7.5,-2.5h1v0.5h-1zM-7,-2h1v0.5h-1zM-5.5,-2h0.5v1h-0.5zM8.5,-2h0.5v0.5h-0.5zM-7.5,-1.5h0.5v0.5h-0.5zM-8,-1h0.5v0.5h-0.5zM-8.5,-0.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 452,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: [
        ['rock', 0.7],
        ['shadow', 0.3],
      ],
      d: 'M-1,-4h0.5v0.5h-0.5zM0.5,-4h2v0.5h-2zM-2,-3.5h2v0.5h-2zM0.5,-3.5h5v1h-5zM-4.5,-3h1.5v0.5h-1.5zM-2.5,-3h2.5v0.5h-2.5zM6,-3h1v0.5h-1zM-5,-2.5h2v1h-2zM-2.5,-2.5h8v0.5h-8zM6,-2.5h2v0.5h-2zM-6.5,-2h1v0.5h-1zM-2.5,-2h12v0.5h-12zM-7,-1.5h1.5v0.5h-1.5zM-5,-1.5h14.5v0.5h-14.5zM-8,-1h17.5v0.5h-17.5zM-9,-0.5h8v0.5h-8zM3,-0.5h6.5v0.5h-6.5zM-9.5,0h7.5v0.5h-7.5zM4,0h5.5v0.5h-5.5zM-9.5,0.5h6.5v0.5h-6.5zM5,0.5h4.5v0.5h-4.5zM-9.5,1h5.5v0.5h-5.5zM6,1h3.5v0.5h-3.5zM-9.5,1.5h5v0.5h-5zM6.5,1.5h3v0.5h-3zM-9.5,2h4.5v0.5h-4.5zM7,2h2.5v0.5h-2.5zM-9.5,2.5h4v0.5h-4zM7.5,2.5h2v1h-2zM-9.5,3h3.5v0.5h-3.5zM-9.5,3.5h3v0.5h-3zM-9.5,4h2.5v0.5h-2.5z',
    },
    {
      paint: [
        ['rock', 0.73],
        ['sail', 0.27],
      ],
      d: 'M-2.5,-5.5h5.5v0.5h-5.5zM-4.5,-5h9.5v0.5h-9.5zM-5.5,-4.5h5v0.5h-5zM2,-4.5h4v0.5h-4zM-6.5,-4h4v0.5h-4zM6,-4h1v0.5h-1zM-8,-3.5h3.5v0.5h-3.5zM6.5,-3.5h1.5v0.5h-1.5zM-8.5,-3h3v0.5h-3zM8,-3h0.5v0.5h-0.5zM-9.5,-2.5h3v0.5h-3zM-10,-2h3v0.5h-3zM-11,-1.5h3v0.5h-3zM-10.5,-1h2v0.5h-2zM-10,-0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'rock',
      d: 'M-0.5,-4.5h2.5v0.5h-2.5zM-2.5,-4h1.5v0.5h-1.5zM-0.5,-4h1v0.5h-1zM2.5,-4h3.5v0.5h-3.5zM-4.5,-3.5h2.5v0.5h-2.5zM0,-3.5h0.5v1h-0.5zM5.5,-3.5h1v0.5h-1zM-5.5,-3h1v0.5h-1zM-3,-3h0.5v1.5h-0.5zM5.5,-3h0.5v1h-0.5zM7,-3h1v0.5h-1zM-6.5,-2.5h1.5v0.5h-1.5zM8,-2.5h1.5v0.5h-1.5zM-7,-2h0.5v0.5h-0.5zM-5.5,-2h0.5v1h-0.5zM-8,-1.5h1v0.5h-1zM-8.5,-1h0.5v0.5h-0.5zM-9.5,-0.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 465,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: [
        ['rock', 0.7],
        ['shadow', 0.3],
      ],
      d: 'M0.5,-5h1.5v0.5h-1.5zM-2,-4.5h2v0.5h-2zM0.5,-4.5h2.5v0.5h-2.5zM-2.5,-4h7.5v0.5h-7.5zM-4,-3.5h1v0.5h-1zM-2.5,-3.5h8v0.5h-8zM-4.5,-3h4.5v0.5h-4.5zM1.5,-3h4v1h-4zM6,-3h0.5v0.5h-0.5zM-5,-2.5h4.5v1.5h-4.5zM6,-2.5h1.5v0.5h-1.5zM-6,-2h0.5v0.5h-0.5zM1.5,-2h6.5v0.5h-6.5zM-6.5,-1.5h1v0.5h-1zM1.5,-1.5h7v0.5h-7zM-7,-1h5.5v0.5h-5.5zM2.5,-1h6v0.5h-6zM-7.5,-0.5h5.5v0.5h-5.5zM3.5,-0.5h5v0.5h-5zM-8.5,0h5.5v1h-5.5zM4,0h4.5v0.5h-4.5zM4.5,0.5h4v0.5h-4zM-8.5,1h5v0.5h-5zM5,1h3.5v0.5h-3.5zM-8.5,1.5h4.5v0.5h-4.5zM5.5,1.5h3v1h-3zM-8.5,2h4v1h-4zM6,2.5h2.5v0.5h-2.5zM-8.5,3h3.5v0.5h-3.5zM6,3h2v0.5h-2zM-8.5,3.5h3v1h-3z',
    },
    {
      paint: [
        ['rock', 0.73],
        ['sail', 0.27],
      ],
      d: 'M-1.5,-6.5h3v0.5h-3zM-3,-6h6v0.5h-6zM-4.5,-5.5h4.5v0.5h-4.5zM0.5,-5.5h3.5v0.5h-3.5zM-5,-5h3v0.5h-3zM3.5,-5h1v0.5h-1zM-6,-4.5h3v0.5h-3zM4.5,-4.5h1v0.5h-1zM-6.5,-4h2.5v0.5h-2.5zM-7.5,-3.5h3v0.5h-3zM-8,-3h2.5v0.5h-2.5zM-8.5,-2.5h2.5v0.5h-2.5zM-9,-2h2.5v0.5h-2.5zM-9.5,-1.5h2.5v0.5h-2.5zM-9,-1h1.5v0.5h-1.5zM-8.5,-0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'rock',
      d: 'M0,-5.5h0.5v0.5h-0.5zM-2,-5h2.5v0.5h-2.5zM2,-5h1.5v0.5h-1.5zM-3,-4.5h1v0.5h-1zM0,-4.5h0.5v0.5h-0.5zM3,-4.5h1.5v0.5h-1.5zM5.5,-4.5h0.5v0.5h-0.5zM-4,-4h1.5v0.5h-1.5zM5,-4h1.5v0.5h-1.5zM-4.5,-3.5h0.5v0.5h-0.5zM-3,-3.5h0.5v0.5h-0.5zM5.5,-3.5h1.5v0.5h-1.5zM-5.5,-3h1v0.5h-1zM0,-3h1.5v0.5h-1.5zM5.5,-3h0.5v1h-0.5zM6.5,-3h1v0.5h-1zM-6,-2.5h1v0.5h-1zM-0.5,-2.5h2v4.5h-2zM7.5,-2.5h0.5v0.5h-0.5zM-6.5,-2h0.5v0.5h-0.5zM-5.5,-2h0.5v1h-0.5zM8,-2h0.5v0.5h-0.5zM-7,-1.5h0.5v0.5h-0.5zM-7.5,-1h0.5v0.5h-0.5zM-8,-0.5h0.5v0.5h-0.5zM-0.5,2h0.5v0.5h-0.5z',
    },
  ],
  pixels: 464,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
